"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStorage = exports.Storage = exports.MemoryStorage = void 0;
var MemoryStorage = (function () {
    function MemoryStorage() {
        this.data = {};
        this.orderedKeys = [];
        this.length = 0;
    }
    MemoryStorage.prototype.getItem = function (key) {
        return key in this.data ? this.data[key] : null;
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        this.orderedKeys.push(key);
        this.data[key] = value;
        this.length++;
        return this.data[key];
    };
    MemoryStorage.prototype.removeItem = function (key) {
        var index = this.orderedKeys.indexOf(key, 0);
        if (index > -1) {
            this.orderedKeys.splice(index, 1);
        }
        delete this.data[key];
        this.length--;
    };
    MemoryStorage.prototype.key = function (index) {
        return this.orderedKeys[index];
    };
    return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;
var Storage = (function () {
    function Storage(store, namespace) {
        this.store = store;
        this.namespace = namespace;
        this.store = store;
        this.namespace = "_baas.".concat(namespace);
    }
    Storage.prototype._generateKey = function (key) {
        return "".concat(this.namespace, ".").concat(key);
    };
    Storage.prototype.get = function (key) {
        return this.store.getItem(this._generateKey(key));
    };
    Storage.prototype.set = function (key, value) {
        return this.store.setItem(this._generateKey(key), value);
    };
    Storage.prototype.remove = function (key) {
        this.store.removeItem(this._generateKey(key));
    };
    return Storage;
}());
exports.Storage = Storage;
function createStorage(options) {
    var storageType = options.storageType, namespace = options.namespace;
    if (storageType === 'localStorage') {
        if (typeof window !== 'undefined' && 'localStorage' in window && window.localStorage !== null) {
            return new Storage(window.localStorage, namespace);
        }
    }
    return new Storage(new MemoryStorage(), namespace);
}
exports.createStorage = createStorage;
//# sourceMappingURL=Storage.js.map